import { InvoiceActions } from './actionTypes';
import {
    archiveInvoice,
    duplicateInvoice,
    getInvoiceById,
    listInvoices,
    sendInvoiceToCustomer,
    unarchiveInvoice,
    updateInvoice,
    updateInvoiceStatus,
} from './client';
import {
    ListInvoicesParams,
    SendInvoiceToCustomerPayload,
    UpdateInvoicePayload,
    UpdateInvoiceStatusPayload,
} from './types';

export const doGetInvoiceById: Function = (invoiceId: string) => async (dispatch: Function) => {
    dispatch({
        type: InvoiceActions.GET_INVOICE_BY_ID_REQUEST,
    });

    try {
        const payload = await getInvoiceById(invoiceId);
        dispatch({
            type: InvoiceActions.GET_INVOICE_BY_ID_SUCCESS,
            payload,
        });
        return payload;
    } catch (e: any) {
        dispatch({
            type: InvoiceActions.GET_INVOICE_BY_ID_ERROR,
            error: e?.response?.data,
        });
        throw e;
    }
};

export const doUpdateInvoice: Function =
    (invoiceId: string, payload: UpdateInvoicePayload) => async (dispatch: Function) => {
        dispatch({
            type: InvoiceActions.UPDATE_INVOICE_REQUEST,
        });

        try {
            const updatedInvoice = await updateInvoice(invoiceId, payload);
            dispatch({
                type: InvoiceActions.UPDATE_INVOICE_SUCCESS,
                payload: updatedInvoice,
            });
            return updatedInvoice;
        } catch (e: any) {
            dispatch({
                type: InvoiceActions.UPDATE_INVOICE_ERROR,
                error: e?.response?.data,
            });
            throw e;
        }
    };

export const doListInvoices: Function = (params?: ListInvoicesParams) => async (dispatch: Function) => {
    dispatch({
        type: InvoiceActions.LIST_INVOICES_REQUEST,
    });
    try {
        const payload = await listInvoices(params);
        dispatch({
            type: InvoiceActions.LIST_INVOICES_SUCCESS,
            payload,
        });
    } catch (e: any) {
        dispatch({
            type: InvoiceActions.LIST_INVOICES_ERROR,
            error: e?.response?.data,
        });
        throw e;
    }
};

export const doArchiveInvoice: Function = (invoiceId: string) => async (dispatch: Function) => {
    dispatch({
        type: InvoiceActions.ARCHIVE_INVOICE_REQUEST,
    });
    try {
        const updatedInvoice = await archiveInvoice(invoiceId);
        dispatch({
            type: InvoiceActions.ARCHIVE_INVOICE_SUCCESS,
            payload: updatedInvoice,
        });
    } catch (e: any) {
        dispatch({
            type: InvoiceActions.ARCHIVE_INVOICE_ERROR,
            error: e?.response?.data,
        });
        throw e;
    }
};

export const doUnarchiveInvoice: Function = (invoiceId: string) => async (dispatch: Function) => {
    dispatch({
        type: InvoiceActions.UNARCHIVE_INVOICE_REQUEST,
    });
    try {
        const updatedInvoice = await unarchiveInvoice(invoiceId);
        dispatch({
            type: InvoiceActions.UNARCHIVE_INVOICE_SUCCESS,
            payload: updatedInvoice,
        });
    } catch (e: any) {
        dispatch({
            type: InvoiceActions.UNARCHIVE_INVOICE_ERROR,
            error: e?.response?.data,
        });
        throw e;
    }
};

export const doDuplicateInvoice: Function = (invoiceId: string) => async (dispatch: Function) => {
    dispatch({
        type: InvoiceActions.DUPLICATE_INVOICE_REQUEST,
    });
    try {
        const duplicatedInvoice = await duplicateInvoice(invoiceId);
        dispatch({
            type: InvoiceActions.DUPLICATE_INVOICE_SUCCESS,
            payload: duplicatedInvoice,
        });
    } catch (e: any) {
        dispatch({
            type: InvoiceActions.DUPLICATE_INVOICE_ERROR,
            error: e?.response?.data,
        });
        throw e;
    }
};

export const doSendInvoiceToCustomer: Function =
    (invoiceId: string, payload: SendInvoiceToCustomerPayload) => async (dispatch: Function) => {
        dispatch({
            type: InvoiceActions.SEND_TO_CLIENT_REQUEST,
        });

        try {
            const response = await sendInvoiceToCustomer(invoiceId, payload);
            dispatch({
                type: InvoiceActions.SEND_TO_CLIENT_SUCCESS,
                invoiceId,
                payload: response,
            });
            return response;
        } catch (e: any) {
            dispatch({
                type: InvoiceActions.SEND_TO_CLIENT_ERROR,
                error: e?.response?.data,
            });
            throw e;
        }
    };

export const doUpdateInvoiceStatus: Function =
    (invoiceId: string, payload: UpdateInvoiceStatusPayload) => async (dispatch: Function) => {
        dispatch({
            type: InvoiceActions.UPDATE_INVOICE_STATUS_REQUEST,
        });

        try {
            const updatedInvoice = await updateInvoiceStatus(invoiceId, payload);
            dispatch({
                type: InvoiceActions.UPDATE_INVOICE_STATUS_SUCCESS,
                payload: updatedInvoice,
            });
        } catch (e: any) {
            dispatch({
                type: InvoiceActions.ARCHIVE_INVOICE_ERROR,
                error: e?.response?.data,
            });
            throw e;
        }
    };
